import { useState } from 'react'

export const useMediaModal = () => {
  const [selectedMedia, setSelectedMedia] = useState(null)

  const openModal = (mediaItem) => {
    setSelectedMedia(mediaItem)
  }

  const closeModal = () => {
    setSelectedMedia(null)
  }

  return {
    selectedMedia,
    openModal,
    closeModal
  }
}